import { autoLcBaromoneyTransferSetting } from '@/locales/ko/views/baromoney-transfer-setting';
import { i18n } from '@/locales';
const lc = autoLcBaromoneyTransferSetting();
export const tableHeader = [
    {
        title: lc('list.table.sourcename'),
        align: 'center',
        width: 350,
    },
    {
        title: lc('list.table.targetname'),
        align: 'center',
        width: 350,
    },
    {
        title: lc('list.table.moveFix'),
        align: 'center',
        width: 100,
    },
    {
        title: lc('list.table.isDeleted'),
        align: 'center',
        width: 100,
    },
    {
        title: lc('list.table.createdAt'),
        align: 'center',
        width: 150,
    },
    {
        title: lc('list.table.applyDate'),
        align: 'center',
        width: 150,
    },
    {
        title: lc('list.table.expireDate'),
        align: 'center',
        width: 150,
    },
    {
        title: lc('list.table.moveMemo'),
        align: 'center',
    },
];
export const enumTargetName = {
    HUB: i18n.t('common.hub'),
    STORE: lc('store'),
};
export const enumServiceType = {
    NONE: lc('detail.servicetype.none'),
    ORDER: lc('detail.servicetype.order'),
    DELIVERY: lc('detail.servicetype.delivery'),
    QUICK: lc('detail.servicetype.quick'),
    LEASE_REMITTANCE: lc('detail.servicetype.lease_remittance'),
};
